import { render } from "./FootballAdminCalcPanel.vue?vue&type=template&id=d6f2a574&scoped=true"
import script from "./FootballAdminCalcPanel.vue?vue&type=script&lang=js"
export * from "./FootballAdminCalcPanel.vue?vue&type=script&lang=js"

import "./FootballAdminCalcPanel.vue?vue&type=style&index=0&id=d6f2a574&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f2a574"]])

export default __exports__